module.exports = __webpack_public_path__ + "main/assets/public/transparent-button/right-arrow.51a4169081c83cfd.svg";